import { format } from 'date-fns';
import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

export const EntitySearchRefetcherV2 = ({
  lastRefreshedAt,
}: {
  lastRefreshedAt?: string | null;
}) => {
  if (lastRefreshedAt == null) return null;

  return (
    <Stack gap="s" alignItems="center">
      <span>
        <Content id={ContentId.DataLastRefreshed} />:
      </span>
      <span>{format(new Date(lastRefreshedAt), 'M/d/yyyy h:mm a')}.</span>
    </Stack>
  );
};
